import { createSlice } from '@reduxjs/toolkit';
import { fetchPurchasedPrivateMedia } from './operations';

const purchasedPrivateMediaSlice = createSlice({
  name: 'purchasedPrivateMedia',
  initialState: {
    items: [],
    pagination: null,
    isLoading: false,
    error: null,
  },
  extraReducers: builder => {
    builder
      .addCase(fetchPurchasedPrivateMedia.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPurchasedPrivateMedia.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload.items;
        state.pagination = {
          page: action.payload.page,
          perPage: action.payload.perPage,
          totalPages: action.payload.totalPages,
          totalCount: action.payload.totalCount,
        };
      })
      .addCase(fetchPurchasedPrivateMedia.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Something went wrong';
      });
  },
});
// Селектори:
export const selectPurchasedPrivateMedia = state =>
  state.purchasedPrivateMedia.items;
export const selectPurchasedPrivateMediaLoading = state =>
  state.purchasedPrivateMedia.isLoading;
export const selectPurchasedPrivateMediaError = state =>
  state.purchasedPrivateMedia.error;

export default purchasedPrivateMediaSlice.reducer;
